import { useContext } from 'react';
import { ISignalrConnectionContext, SignalrConnectionContext } from 'context';

export function useSignalrConnection(): ISignalrConnectionContext {
  return useContext(SignalrConnectionContext)!;
}
